import Vue from 'vue'
// Vue.config.devtools = true
import Vuex from 'vuex'
import VueTheMask from 'vue-the-mask'

// Our modules
import billing from './modules/billing'
import contacts from './modules/contacts'
import dns from './modules/dns'
import hosting from './modules/hosting'
import notifications from './modules/notifications'
import modals from './modules/modals'
import servers from './modules/servers'
import services from './modules/services'
import user from './modules/user'
import notices from './modules/notices'
import cart from './modules/cart'
import ssu from './modules/ssu'
import logging from './modules/logging'

// Register vuex with Vue
Vue.use(Vuex)
// Register hotkey handler


// Import mask for forums
Vue.use(VueTheMask)

const debug = process.env.NODE_ENV !== 'production'

// Create and export a new Vuex store
export default new Vuex.Store({
  modules: {
    billing,
    contacts,
    dns,
    hosting,
    notifications,
    servers,
    services,
    user,
    notices,
    modals,
    cart,
    ssu,
    logging
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js